import { FlagFreezeLevelType, IToggleConfig, ToggleConfigType } from '@cemex-core/cmx-rollout-toggle-v1';
import {
  AddNewProductOneClickFeature,
  AdjustmentOrderFeature,
  BoomPumpFeature,
  CancelOrderFeature,
  CatalogPCMFeature,
  ChatBotAivoFeature,
  ChatBotWizelineFeature,
  CreatePodRequestFeature,
  CreateReceivingPersonModalFeature,
  ExtendedLogFeature,
  HideIndicativePricesFeature,
  IsOnlineOrderFeature,
  IsSalesReadonlyFeature,
  LocationAndSpecificationFeature,
  ModifyOrderFeature,
  NeorisLogoFeature,
  NewActionLogsFeature,
  OnHoldOrderFeature,
  OrderActionMenuFeature,
  PumpingServiceFeature,
  ReceiveMyProductsFromV3Feature,
  RepeatOrderFeature,
  RmxAdditionalInfoFeature,
  ShowLoadDefaultCatalogValuesFeature,
  ShowLoadDefaultReceivingPerson,
  ShowProductCatalogFavoriteTabFeature,
  ShowProductCatalogMyListTabFeature,
  ShowProductCatalogProductCatTabFeature,
  ShowProductCatalogSuggestedTabFeature,
  ShowReqAndOrderFeature,
  EnableDownloadExcelFeature,
  ShowTermsCheckboxOnUploadDocument,
  ShowUploadDocumentDropdownsFeature,
  TimeNegotiationFeature,
  WalkMeFeature,
  HideMultiplePurchaseOrderFeature,
  CoBrowseFeature,
  SimmaOnlineFeature,
  OrderSubscriptionFeature,
  AutomaticValidationFeature,
  DcoImprovementFeature,
  EnableCounterofferMatchBulkCEMFeature,
  ReceivingPersonTestModifierFeature,
  EnableOrderAvailabilityExpirationTimeFeature,
  EnableOrderModificationExpirationTimeFeature,
  EnablePODDropdownFeature,
  ProductDescriptionHomologationFeature,
  EnableSpecialScenariosMooFeature,
  EnableBusinessDaysCutOffFeature,
  EnableActionLogV7Feature,
  EnableContractsExpirationDateFeature,
  EnablePODMooDropdownFeature,
  EnablePODDeleteMooFeature,
  OrderMissingFieldsAlert,
  PalletsDefaultUnitBagCemFeature,
  PaymentTermsFeature,
  LoadSizeFeature,
  DeliveryTimeWindowSelectFeature,
  DeliveryTimePickerFeature,
  SameDayOrderFeature,
  PumpPrimerAndUnloadTypeFeature,
  EnableAdmixturesProductTypeFeature,
  ShowOneDeliveryMethodForAdmixturesFeature,
  OutOfServiceHoursFeature,
  ShowCancelOrderButtonFeature,
  EnableAfterCutOffBulkCemFeature,
  NextBusinessDayPreSelectionFeature,
  JobSiteRestrictedFeature,
  TrucksDriversCertified,
  RepeatActionBlkAdt,
  ModifyActionBlkAdt,
  CancelActionBlkAdt,
  CallActionsBlkAdt,
  UnloadTypeAndApplicationCataloguesHomologationFeature,
  DisableEmailReceivingPersonPrefillFeature,
  CashOrderBlkAdt,
  OdmOrderCreationBlkAdt,
  CountOrderQuantityFromProductsFeature,
  MOPrefillFeature,
  SameDayMOOFeature,
  OrderRejectionCodeFeature,
  EmeaCalendarViewImprovementsFeature,
  HideRoleReceivingPersonFeature,
  DcoWaitingListRedesign2025,
  ChatBotAivoRealocatedFeature,
  EnableNewPodArkikFeature,
  AgreementBalanceValidationFeature,
} from '../features/';
import { CalendarViewFeature } from '../features/calendar-view.feature';
import { RmsWayFeature } from '../features/rms-way.feature';
import { ShowProductCatalogOrdersTabFeature } from '../features/show-product-catalog-orders-tab.feature';
import { Features } from '../models/features.enum';
import { PurchaseOrderMaskValidationFeature } from '../features/purchase-order-mask-validation.feature';
import { SMSSubscriptionFeature } from '../features/sms-subscription.feature';
import { SMSNotificationTestModifierFeature } from '../features/sms-notification-test-modifier.feature';
import { CalendarViewV2Feature } from '../features/calendar-view-v2.feature';
import { EnableBusinessDays } from '../features/enable-business-days.feature';
import { EnableOdmOrderCreation } from '../features/enable-odm-order-creation.feature';
import { EnableContractDetail } from '../features/enable-contract-detail.feature';
import { EnableSpacingValidationByQtyLoadSize } from '../features/enable-spacing-validation-qty-loadsize.feature';
import { OrderSubscriptionMOOFeature } from '../features/order-subscription-moo.feature';
import { RemoveContractFieldEnabled } from '../features/RemoveContractFieldEnabled.feature';
import {
  AddReceivingPersonMoo,
  DeliveryInstructionsFieldMoo,
  OrderDetailLinkMOOFeature,
  RestrictedJobsiteMoo,
  CertifiedTrucksDriversMoo,
  EnableDefaultTimeAddMooFeature,
  EnableDefaultTimeDuplicateMooFeature,
  AutoSelectJobsiteMoo,
  SetNonWorkingDaysPickerMooFeature,
} from '../features/moo.feature';
import { TimeFormatByCountryUiFeature } from '../features/time-format-by-country-ui.feature';
import { TimeFormatByLanguageUiFeature } from '../features/time-format-by-language-ui.feature';
import { DateFormatByLanguageUiFeature } from '../features/date-format-by-language-ui.feature';
import { DateFormatByCountryUiFeature } from '../features/date-format-by-country-ui.feature';
import { TimeFormatByDefaultUiFeature } from '../features/time-format-by-default-ui.feature';
import { DateFormatByDefaultUiFeature } from '../features/date-format-by-default-ui.feature';
import { DateFirstDayWeekByCountryUiFeature } from '../features/date-first-day-week-by-country-ui.feature';
import { DateFirstDayWeekByDefaultUiFeature } from '../features/date-first-day-week-by-default-ui.feature';
import { DateFirstDayWeekByLanguageUiFeature } from '../features/date-first-day-week-by-language-ui.feature';
import { ButtonsOnDateAndTimePicker } from '../features/buttons-on-date-and-time-picker.feature';
import { ShowSpecificationManeuverFeature } from '../features/additional-services.feature';
import { EnableOutRangeTagFeature } from '../features/enable-outrange-tag.feature';
import { CloudContactModule } from '../features/cloud-contact-module-enabled.feature';
import { DeliveryBlockedFeature } from '../features/delivery-blocked.feature';
import { ShowUnderRiskColorTag } from '../features/hideUnderRiskColorTag.feature';
import { EnableUnitsInAdmixturesFeature } from '../features/enable-multiple-units-in-admixtures.feature';
import { RestrictedVolumeLoadSizeFeature } from '../features/restricted-volume-load-size.feature';
import { NewOrderAfterCutoffFeature } from '../features/new-order-after-cutoff.feature';
import { OrderConfirmToDispatchFeature } from '../features/order-confirm-to-dispatch.feature';
import { EnableJobsiteDropdownRepearOrder } from '../features/enable-jobsite-dropdown-repeatOrder.feature';
import { PodFilterFeature } from '../features/pod-filter.feature';
import { EnableSecondMapCreateJobsite } from '../features/enable-second-map-create-obsite.feature';
import { ImprovementsModifyOrderRulesFeature } from '../features/improvements-modify-order-rules.feature';
import { CreditLimitExceededMessageFeature } from '../features/credit-limit-exceeded-message.feature';
import { LeadTimesApiBlkAdt } from '../features/lead-times-api-blk-adt.feature';
import { ActionLogsV7MultiProductFeature } from '../features/action-logV7-multi-product.feature';
import { DisableCommentsRMXFeature } from '../features/enable-comments-rmx.feature';
import { ProjectProfilesFeature } from '../features/project-profiles.feature';
import { RepeatArkikFeature } from '../features/repeat-arkik.feature';
import { AdditionalInfoFeature } from '../features/additional-info.feature';
import { NewOrderFlowFeature } from '../features/new-order-flow.feature';
import { DCOTimeExpirationMOOFeature } from '../features/dco-time-expiration-moo.feature';
import { CleanUpFeature } from '../features/clean-up.feature';
import { EnablePODCreateOnModifyOrderFeature } from '../features/pod-create-on-modify-order.feature';
import { EnablePODCreateOnRepeatOrderFeature } from '../features/pod-create-on-repeat-order.feature';
import { NofJobsiteFullAddressFeature } from '../features/nof-jobsite-full-address.feature';
import { NofJobsiteMultipleLocationsFeature } from '../features/nof-jobsite-multiple-locations.feature';
import { OrderListIconActionsMenuFeature } from '../features/order-list-icon-actions-menu.feature';
import { HideBackButtonFromLastStep } from '../features/hide-back-button-from-last-step.feature';
import { CustomSpacingFeature } from '../features/custom-spacing.feature';
import { PrefillMooImprovementsAllWeeksFeature } from '../features/prefill-moo-improvements-all-weeks';
import { ShowPodInsteadOfJobsiteFeature } from '../features/show-pod-instead-of-jobsite.feature';
import { EnableCalculationAvailabilityDate } from '../features/enable-calculation-availability-date.feature';
import { EnableCalculationAvailabilityDateForCancel } from '../features/enable-calculation-availability-date-for-cancel.feature';
import { EnableCalculationAvailabilityDateForModify } from '../features/enable-calculation-availability-date-for-modify.feature';
import { DcoLogsStatisticsFeature } from '@ordersnproducts/features/features/dco-logs-statistics.feature';
import { EnabledVariousLocationV4 } from '../features/EnableVariosLocationV4.feature';
import { CancelErrorHandlingFeature } from '../features/cancel_error_handling.feature';
import { PrefillMooIgnoreExperienceCheckFeature } from '../features/prefill-moo-ignore-experience-check.feature';
import { FormErrorHandlingOnTouchedFeature } from '@ordersnproducts/features/features/form-error-handling-on-touched.feature';
import { ModifyArkikFeature } from '../features/modify-arkik.feature';
import { CancelErrorHandlingTimeFeature } from '../features/cancel_error_handling_time.feature';
import { HideUnloadTimeFeature } from '../features/hide-unload-time.feature';
import { LogisticChargesFeature } from '../features/logistic-charges.feature';
import { ModifiedFieldsArkikFeature } from '@ordersnproducts/features/features/modified-fields-arkik.feature';
import { BuildingMaterialsFeature } from '../features/building-materials.feature';
import { ReceivingPersonSynchronizationFeature } from '../features/receiving-person-synchronization.feature';

export const toggleConfig: IToggleConfig[] = [
  {
    name: Features.RepeatOrder,
    handler: RepeatOrderFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.CancelOrder,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
      options: { freeze: FlagFreezeLevelType.NONE },
    },
  },
  {
    name: Features.CancelOrder_ADT,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelOrder_AGG,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelOrder_CEM,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelOrder_RMX,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelOrder_MLT,
    handler: CancelOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ShowReqAndOrder,
    handler: ShowReqAndOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableDownloadExcel,
    handler: EnableDownloadExcelFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ModifyOrder,
    handler: ModifyOrderFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.ON_HOLD_ORDER,
    handler: OnHoldOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.AdjustmentOrder,
    handler: AdjustmentOrderFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.RmxAdditionalInfo,
    handler: RmxAdditionalInfoFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.NeorisLogo,
    handler: NeorisLogoFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.TimeNegotiation,
    handler: TimeNegotiationFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.CreateReceivingPersonModalFeature,
    handler: CreateReceivingPersonModalFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.HideIndicativePrices,
    handler: HideIndicativePricesFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.NewActionLogs,
    handler: NewActionLogsFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.ShowUploadDocumentDropdownsFeature,
    handler: ShowUploadDocumentDropdownsFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.IsOnlineOrder,
    handler: IsOnlineOrderFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.WalkMe,
    handler: WalkMeFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.PumpingService,
    handler: PumpingServiceFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: '',
    },
  },
  {
    name: Features.ChatBotWizeline,
    handler: ChatBotWizelineFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.ChatBotAivo,
    handler: ChatBotAivoFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.ChatBotAivoRealocated,
    handler: ChatBotAivoRealocatedFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.ReceiveMyProductsFromV3,
    handler: ReceiveMyProductsFromV3Feature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.ShowTermsCheckboxOnUploadDocument,
    handler: ShowTermsCheckboxOnUploadDocument,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.OrdersProductCatalogOrdersTab,
    handler: ShowProductCatalogOrdersTabFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.OrdersProductCatalogSuggestedTab,
    handler: ShowProductCatalogSuggestedTabFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.OrdersProductCatalogProductCatTab,
    handler: ShowProductCatalogProductCatTabFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.OrdersProductCatalogFavoriteTab,
    handler: ShowProductCatalogFavoriteTabFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.OrdersProductCatalogMyListTab,
    handler: ShowProductCatalogMyListTabFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.LoadDefaultReceivingPerson,
    handler: ShowLoadDefaultReceivingPerson,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.IsSalesReadonly,
    handler: IsSalesReadonlyFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.CreatePodRequest,
    handler: CreatePodRequestFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.LoadDefaultCatalogValues,
    handler: ShowLoadDefaultCatalogValuesFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.BoomPump,
    handler: BoomPumpFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.CatalogPCM,
    handler: CatalogPCMFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.OrderActionMenu,
    handler: OrderActionMenuFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.RmsWay,
    handler: RmsWayFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
      options: { freeze: FlagFreezeLevelType.NONE },
    },
  },
  {
    name: Features.ExtendedLogTab,
    handler: ExtendedLogFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.AddNewProductOneClick,
    handler: AddNewProductOneClickFeature,
    flag: {
      type: ToggleConfigType.Flag,
    },
  },
  {
    name: Features.CalendarView,
    handler: CalendarViewFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.LocationAndSpecification,
    handler: LocationAndSpecificationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
      options: { freeze: FlagFreezeLevelType.NONE },
    },
  },
  {
    name: Features.EnableActionLogV7,
    handler: EnableActionLogV7Feature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_REPEAT_ARKIK,
    handler: RepeatArkikFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PurchaseOrderMaskValidation,
    handler: PurchaseOrderMaskValidationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.HideMultiplePurchaseOrder,
    handler: HideMultiplePurchaseOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.AutomaticValidation,
    handler: AutomaticValidationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.CoBrowse,
    handler: CoBrowseFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SimmaOnline,
    handler: SimmaOnlineFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_SUBSCRIPTION,
    handler: OrderSubscriptionFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DELIVERY_BLOCKED,
    handler: DeliveryBlockedFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableCounterofferMatchBulkCEM,
    handler: EnableCounterofferMatchBulkCEMFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DCO_IMPROV,
    handler: DcoImprovementFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DcoWaitingListRedesign2025,
    handler: DcoWaitingListRedesign2025,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ReceivingPersonTestModifier,
    handler: ReceivingPersonTestModifierFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SMSSubscription,
    handler: SMSSubscriptionFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SMSNotificationTestModifier,
    handler: SMSNotificationTestModifierFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CalendarViewNewVersion,
    handler: CalendarViewV2Feature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableOrderAvailabilityExpirationTime,
    handler: EnableOrderAvailabilityExpirationTimeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableOrderModificationExpirationTime,
    handler: EnableOrderModificationExpirationTimeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ProductDescriptionHomologation,
    handler: ProductDescriptionHomologationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },

  {
    name: Features.ShowPodInsteadOfJobsiteFeature,
    handler: ShowPodInsteadOfJobsiteFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },

  {
    name: Features.EnablePODDropdownFeature,
    handler: EnablePODDropdownFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnabledBusinessDays,
    handler: EnableBusinessDays,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableSpecialScenariosMoo,
    handler: EnableSpecialScenariosMooFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableOdmOrderCreation,
    handler: EnableOdmOrderCreation,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableContractDetail,
    handler: EnableContractDetail,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.EnableBusinessDaysCutOff,
    handler: EnableBusinessDaysCutOffFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableAfterCutOffBulkCem,
    handler: EnableAfterCutOffBulkCemFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ContractsExpirationDate,
    handler: EnableContractsExpirationDateFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnableSpacingValidationByQtyLoadSize,
    handler: EnableSpacingValidationByQtyLoadSize,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_SUBSCRIPTION_MOO,
    handler: OrderSubscriptionMOOFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnablePODMooDropdownFeature,
    handler: EnablePODMooDropdownFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnablePODDeleteMooFeature,
    handler: EnablePODDeleteMooFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnablePODCreateOnModifyOrderFeature,
    handler: EnablePODCreateOnModifyOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EnablePODCreateOnRepeatOrderFeature,
    handler: EnablePODCreateOnRepeatOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.RemoveContractFieldEnabled,
    handler: RemoveContractFieldEnabled,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ADD_RECEIVING_PERSON_MOO,
    handler: AddReceivingPersonMoo,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.RESTRICTED_JOBSITE_MOO,
    handler: RestrictedJobsiteMoo,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CERTIFIED_TRUCKS_DRIVERS_MOO,
    handler: CertifiedTrucksDriversMoo,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_MISSING_FIELDS_ALERT,
    handler: OrderMissingFieldsAlert,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DELIVERY_INSTRUCTIONS_FIELD_MOO,
    handler: DeliveryInstructionsFieldMoo,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.TIME_FORMAT_BY_DEFAULT_UI,
    handler: TimeFormatByDefaultUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.TIME_FORMAT_BY_LANG_UI,
    handler: TimeFormatByLanguageUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.TIME_FORMAT_BY_COUNTRY_UI,
    handler: TimeFormatByCountryUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DISABLE_COMMENTS_RMX,
    handler: DisableCommentsRMXFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FORMAT_BY_DEFAULT_UI,
    handler: DateFormatByDefaultUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FORMAT_BY_LANG_UI,
    handler: DateFormatByLanguageUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FORMAT_BY_COUNTRY_UI,
    handler: DateFormatByCountryUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FIRST_DAY_WEEK_BY_COUNTRY_UI,
    handler: DateFirstDayWeekByCountryUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FIRST_DAY_WEEK_BY_DEFAULT_UI,
    handler: DateFirstDayWeekByDefaultUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DATE_FIRST_DAY_WEEK_BY_LANG_UI,
    handler: DateFirstDayWeekByLanguageUiFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_DETAIL_LINK_MOO,
    handler: OrderDetailLinkMOOFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PALLETS_DEFAULT_UNIT_BAG_CEM,
    handler: PalletsDefaultUnitBagCemFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PAYMENT_TERMS,
    handler: PaymentTermsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.LOAD_SIZE,
    handler: LoadSizeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.ORDER_CONFIRM_TO_DISPATCH,
    handler: OrderConfirmToDispatchFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DELIVERY_TIME_WINDOW_SELECT,
    handler: DeliveryTimeWindowSelectFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SAME_DAY_ORDER,
    handler: SameDayOrderFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DELIVERY_TIME_PICKER,
    handler: DeliveryTimePickerFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: true,
    },
  },
  {
    name: Features.DATE_AND_TIME_CTRL_BTNS_UI,
    handler: ButtonsOnDateAndTimePicker,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SHOW_SPECIFICATION_MANEUVER,
    handler: ShowSpecificationManeuverFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PUMP_PRIMER,
    handler: PumpPrimerAndUnloadTypeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_ADMIXTURES_PRODUCT_TYPE,
    handler: EnableAdmixturesProductTypeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SHOW_ONE_DELIVERY_METHOD_FOR_ADMIXTURES,
    handler: ShowOneDeliveryMethodForAdmixturesFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.OUT_OF_SERVICE_HOURS,
    handler: OutOfServiceHoursFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_OUT_RANGE_TAG,
    handler: EnableOutRangeTagFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CLOUD_CONTACT_MODULE,
    handler: CloudContactModule,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_CANCEL_BUTTON,
    handler: ShowCancelOrderButtonFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.UNDER_RISK_COLORTAG,
    handler: ShowUnderRiskColorTag,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_MULTIPLE_UNITS_IN_ADMIXTURES,
    handler: EnableUnitsInAdmixturesFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.RESTRICTED_LOAD_SIZE_AND_VOLUME,
    handler: RestrictedVolumeLoadSizeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.NEW_ORDER_AFTER_CUT_OFF,
    handler: NewOrderAfterCutoffFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.NEXT_BUSINESS_DAY_PRE_SELECTION,
    handler: NextBusinessDayPreSelectionFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.LEAD_TIMES_API_BLK_ADT,
    handler: LeadTimesApiBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.JOBSITE_RESTRICTED,
    handler: JobSiteRestrictedFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.TRUCKS_DRIVERS_CERTIFIED,
    handler: TrucksDriversCertified,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CALL_ACTIONS_BLK_ADT,
    handler: CallActionsBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLED_JOBSITE_DROPDOWN_REPEAT_ORDER,
    handler: EnableJobsiteDropdownRepearOrder,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.REPEAT_ACTION_BLK_ADT,
    handler: RepeatActionBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_POD_FILTER,
    handler: PodFilterFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.MODIFY_ACTION_BLK_ADT,
    handler: ModifyActionBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DEFAULT_TIME_ADD_MOO,
    handler: EnableDefaultTimeAddMooFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DEFAULT_TIME_DUPLICATE_MOO,
    handler: EnableDefaultTimeDuplicateMooFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.AUTO_SELECT_JOBSITE_MOO,
    handler: AutoSelectJobsiteMoo,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SET_NON_WORKING_DAYS_PICKER_MOO,
    handler: SetNonWorkingDaysPickerMooFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLED_SECOND_MAP_CREATE_JOBSITE,
    handler: EnableSecondMapCreateJobsite,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.IMPROVEMENTS_MODIFY_ORDER_RULES,
    handler: ImprovementsModifyOrderRulesFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CREDIT_LIMIT_EXCEEDED_MESSAGE,
    handler: CreditLimitExceededMessageFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CANCEL_ACTION_BLK_ADT,
    handler: CancelActionBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ACTION_LOGS_V7_MULTI_PRODUCT,
    handler: ActionLogsV7MultiProductFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION,
    handler: UnloadTypeAndApplicationCataloguesHomologationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.HIDE_ROLE_RECEIVING_PERSON,
    handler: HideRoleReceivingPersonFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DISABLE_EMAIL_RECEIVING_PERSON_PREFILL,
    handler: DisableEmailReceivingPersonPrefillFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CASH_ORDER_BLK_ADT,
    handler: CashOrderBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ODM_ORDER_CREATION_BLK_ADT,
    handler: OdmOrderCreationBlkAdt,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_LIST_ICON_ACTIONS_MENU,
    handler: OrderListIconActionsMenuFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PREFILL_MOO,
    handler: MOPrefillFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PREFILL_MOO_IMPROVEMENTS_ALL_WEEKS,
    handler: PrefillMooImprovementsAllWeeksFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.PROJECT_PROFILES,
    handler: ProjectProfilesFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.SAME_DAY_MOO,
    handler: SameDayMOOFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.COUNT_ORDER_QUANTITY_FROM_PRODUCTS,
    handler: CountOrderQuantityFromProductsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_REJECTION_CODE,
    handler: OrderRejectionCodeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ADDITIONAL_INFO,
    handler: AdditionalInfoFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.NEW_ORDER_FLOW,
    handler: NewOrderFlowFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DCO_TIME_EXPIRATION_MOO,
    handler: DCOTimeExpirationMOOFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CLEAN_UP,
    handler: CleanUpFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.EMEA_CALENDAR_VIEW_IMPROVEMENTS,
    handler: EmeaCalendarViewImprovementsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.NOF_JOBSITE_FULL_ADDRESS,
    handler: NofJobsiteFullAddressFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.NOF_JOBSITE_MULTIPLE_LOCATIONS,
    handler: NofJobsiteMultipleLocationsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.HIDE_BACK_BUTTON_FROM_LAST_STEP,
    handler: HideBackButtonFromLastStep,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CUSTOM_SPACING,
    handler: CustomSpacingFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_CALCULATION_AVAILABILITY_DATE,
    handler: EnableCalculationAvailabilityDate,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_CALCULATION_AVAILABILITY_DATE_FOR_CANCEL,
    handler: EnableCalculationAvailabilityDateForCancel,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_CALCULATION_AVAILABILITY_DATE_FOR_MODIFY,
    handler: EnableCalculationAvailabilityDateForModify,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.DCO_LOGS_STATISTICS,
    handler: DcoLogsStatisticsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_VARIOUS_LOCATION_V4,
    handler: EnabledVariousLocationV4,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.FORM_ERROR_HANDLING_ON_TOUCHED,
    handler: FormErrorHandlingOnTouchedFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelErrorHandling,
    handler: CancelErrorHandlingFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.CancelErrorHandlingTime,
    handler: CancelErrorHandlingTimeFeature,
    flag: {
      type: ToggleConfigType.Configuration,
      defaultValue: 10,
    },
  },
  {
    name: Features.PREFILL_MO_IGNORE_EXPERIENCE_CHECK,
    handler: PrefillMooIgnoreExperienceCheckFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_MODIFY_ARKIK,
    handler: ModifyArkikFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_NEW_POD_ARKIK,
    handler: EnableNewPodArkikFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.HIDE_UNLOAD_TIME,
    handler: HideUnloadTimeFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.LOGISTIC_CHARGES,
    handler: LogisticChargesFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.MODIFIED_FIELDS_ARKIK,
    handler: ModifiedFieldsArkikFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ENABLE_BUILDING_MATERIALS,
    handler: BuildingMaterialsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.ORDER_ANALYTICS_US,
    handler: BuildingMaterialsFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.AGREEMENT_BALANCE_VALIDATION,
    handler: AgreementBalanceValidationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
  {
    name: Features.RECEIVING_PERSON_SYNCHRONIZATION,
    handler: ReceivingPersonSynchronizationFeature,
    flag: {
      type: ToggleConfigType.Flag,
      defaultValue: false,
    },
  },
];
